import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import Dayoff from '../js/dayoff.js';
import moment from 'moment'; // import AutoNumeric from 'autonumeric';
//

var DayoffPopup = {
  pn: 'div[data-name="dayoff-popup"]',
  popup: null,
  init: function init(popup) {
    this.popup = popup;
    var self = this;
    var $from = $(self.pn + ' input[name="from_date"]');
    var $to = $(self.pn + ' input[name="to_date"]');
    var today = new Date();
    Base.app.calendar.create({
      inputEl: $from,
      dateFormat: 'd/m/yyyy',
      minDate: today
    });
    Base.app.calendar.create({
      inputEl: $to,
      dateFormat: 'd/m/yyyy',
      minDate: today
    });
    $(self.pn + ' .save').click(function () {
      self.save();
    });
  },
  save: function () {
    var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var self, formdata, fd, td, diff, datarows, i, d, d1, data, loader, rs, rows;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              formdata = Base.app.form.convertToData($(self.pn + ' .form'));

              if (!(formdata.from_date == '' || formdata.to_date == '')) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", Utils.errorDialog('Ngày nghỉ không hợp lệ'));

            case 4:
              fd = moment(formdata.from_date, Base.dateFormat);
              td = moment(formdata.to_date, Base.dateFormat);
              diff = td.diff(fd, 'days');

              if (!(diff < 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", Utils.errorDialog('Ngày nghỉ không hợp lệ'));

            case 9:
              if (!(diff > Base.initdata.maximum_date_off)) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", Utils.errorDialog("Kh\xF4ng \u0111\u01B0\u1EE3c n\u1ED9p 1 \u0111\u01A1n ngh\u1EC9 qu\xE1 ".concat(Base.initdata.maximum_date_off, " ng\xE0y")));

            case 11:
              datarows = [];

              for (i = 0; i <= diff; i++) {
                d = fd.clone().add(i, 'days');
                d1 = d.format('YYYY-MM-DD');
                data = {
                  id_emp: Base.user.id,
                  working_date: d1
                };
                datarows.push(data);
              }

              loader = Base.app.dialog.preloader();
              _context.next = 16;
              return Base.api('Dayoff', 'add', {
                datarows: datarows
              });

            case 16:
              rs = _context.sent;
              loader.close();

              if (rs.result == "success" && rs.rows.length > 0) {
                Utils.infoDialog('Đã gửi đơn xin nghỉ. Chờ xét duyệt');
                rows = [];
                rs.rows.forEach(function (item, i) {
                  item.name = Base.user.name;
                  item.status = null;
                  var row = item;
                  rows.push(row);
                });
                Dayoff.updateTable($(Dayoff.pn + ' .data-table tbody'), {
                  rows: rows
                });
              } else if (rs.result == "success" && rs.rows.length == 0) {
                Utils.infoDialog('Bạn đã xin nghỉ vào các ngày này.');
              } else {
                Utils.errorDialog('Đã xảy ra lỗi máy chủ. Vui lòng thử lại sau.');
              }

              self.popup.close();

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function save() {
      return _save.apply(this, arguments);
    }

    return save;
  }()
};
export default (function ($prop, ctx) {
  ctx.$on('popup:open', function (evt) {
    DayoffPopup.init(evt.target.f7Modal);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup" data-name="dayoff-popup">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title">Xin nghỉ</div>
        <div class="right">
          <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
        </div>
      </div>
    </div>
    <div class="page-content no-padding">
      <div class="list no-margin">
        <ul class="form">
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Từ ngày</div>
              <div class="item-input-wrap">
                <input type="text" name="from_date"/>
              </div>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">Đến ngày</div>
              <div class="item-input-wrap">
                <input type="text" name="to_date"/>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <a href="#" class="button button-fill save">Xác nhận</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
`
    }
    ;
});